import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../user.service';
import { LoginDetail } from '../login-detail';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { IUser } from '../interfaces/iuser';
import { User } from '../model/user';
import { browserRefresh } from '../app.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit, OnDestroy {
 

  public user: IUser;
  ld : LoginDetail; 
  private _isLogin: boolean;
  public browserRefresh: boolean;
  public subscription:Subscription;

 
  //loginHasError = true;
  constructor(private userservice : AuthService, private router:Router) { }

  public get isLogin(): boolean {
    return this._isLogin;
  }

  ngOnInit() {
     this.ld = {username:"", password:""};
     this._isLogin = false;
     this.browserRefresh =browserRefresh;
  }

  onSubmit(){
    //this.userservice.login(this.ld);
    this.subscription=this.userservice.login1(this.ld).subscribe(tokenResult=>{
         this.router.navigate(['/admin']);
      })
   }

   ngOnDestroy(): void {
    //this.subscription.unsubscribe;
  }
}
